"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var use_theme_1 = __importDefault(require("../hooks/use-theme"));
var tailwind_1 = __importDefault(require("../utils/tailwind"));
var styles = (0, tailwind_1.default)({
  container: "",
  innerContainer: "\n    tw-relative\n    tw-overflow-hidden\n    ".concat(react_device_detect_1.isMobile ? 'tw-h-screen' : ''),
  closeButton: "\n    tw-absolute\n    tw-top-5\n    ".concat(react_device_detect_1.isMobile ? 'tw-right-2' : 'tw-right-5', "\n    hover:tw-opacity-80\n    tw-rounded\n    tw-z-20"),
  backButton: "\n    tw-absolute\n    tw-top-5\n    ".concat(react_device_detect_1.isMobile ? 'tw-left-2' : 'tw-left-5', "\n    hover:tw-opacity-80\n    tw-rounded\n    tw-z-20"),
  svg: "\n    tw-h-5\n    tw-w-5\n    tw-fill-current",
  layout: "\n    tw-flex\n    tw-flex-row\n    tw-border-solid\n    tw-divide-x\n    tw-h-full",
  trayContainer: "\n    tw-flex\n    tw-flex-col\n    tw-p-4\n    tw-h-full\n    ".concat(react_device_detect_1.isMobile ? '' : 'tw-basis-3/12'),
  contentContainer: "\n    tw-flex\n    tw-flex-col\n    tw-py-4\n    tw-px-6\n    tw-h-full\n    ".concat(react_device_detect_1.isMobile ? 'tw-items-center' : '', "\n    ").concat(react_device_detect_1.isMobile ? '' : 'tw-basis-9/12')
});
function ModalContainer(_ref) {
  var onBack = _ref.onBack,
    onClose = _ref.onClose,
    selectedProvider = _ref.selectedProvider,
    tray = _ref.tray,
    content = _ref.content;
  var theme = (0, use_theme_1.default)();
  var contentToRender = null;
  if (react_device_detect_1.isMobile) {
    if (selectedProvider) {
      contentToRender = react_1.default.createElement("div", {
        className: styles.trayContainer
      }, content);
    } else {
      contentToRender = react_1.default.createElement("div", {
        className: styles.contentContainer
      }, tray);
    }
  } else {
    contentToRender = react_1.default.createElement("div", {
      className: styles.layout
    }, react_1.default.createElement("div", {
      className: styles.trayContainer
    }, tray), react_1.default.createElement("div", {
      className: styles.contentContainer,
      style: {
        borderColor: theme.muted
      }
    }, content));
  }
  return react_1.default.createElement("div", {
    className: "react-celo ".concat(styles.container),
    style: {
      background: theme.background
    }
  }, react_1.default.createElement("div", {
    className: "react-celo-connect-container ".concat(styles.innerContainer),
    style: {
      color: theme.textSecondary
    }
  }, react_1.default.createElement("button", {
    onClick: onClose,
    className: styles.closeButton
  }, react_1.default.createElement("svg", {
    className: styles.svg,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, react_1.default.createElement("path", {
    d: "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
  })), ' '), react_device_detect_1.isMobile && selectedProvider && react_1.default.createElement("button", {
    onClick: onBack,
    className: styles.backButton
  }, react_1.default.createElement("svg", {
    className: styles.svg,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, react_1.default.createElement("path", {
    d: "M9.375 233.4l128-128c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L109.3 224H480c17.69 0 32 14.31 32 32s-14.31 32-32 32H109.3l73.38 73.38c12.5 12.5 12.5 32.75 0 45.25c-12.49 12.49-32.74 12.51-45.25 0l-128-128C-3.125 266.1-3.125 245.9 9.375 233.4z"
  })), ' '), contentToRender));
}
exports.default = ModalContainer;